import {Card} from "@/components/card/Card.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {durationSecFn} from "@/lib/format.tsx";
import {CheckTypeDisplay, Service} from "@/lib/types/checks.ts";

export const ServiceSummary = ({service}: {service: Service}) => (
  <Card>
    <div className="row">
      <div className="col-md-6">
        <div className="fs-4 fw-bold text-primary">{service.name}</div>
        <Tooltip tooltipContent={service.msp_address} delayMs={500}>
          <div className="ellipsis-overflow">{service.msp_address}</div>
        </Tooltip>
      </div>
      <div className="col-md-3 offset-md-3">
        <table>
          <tbody>
            <tr>
              <td className="fw-semibold text-uppercase">Check type</td>
              <td>
                <span className="badge rounded-pill text-bg-light fs-7">
                  {CheckTypeDisplay[service.monitoring_service_type]}
                </span>
              </td>
            </tr>
            <tr>
              <td className="fw-semibold text-uppercase">Interval</td>
              <td>
                <span className="badge rounded-pill text-bg-light fs-7">
                  {durationSecFn(service.msp_interval * 60)}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Card>
);
